'use client'
import React, { FC } from 'react'
import classNames from 'classnames'

import GradientText from '@/components/gradient-text'
import EmailWaitlist from '@/components/email-waitlist'
import { MINT_ALERTS, LAUNCH_ALERTS } from '@/utils/constants'

import styles from './WalletItemsEmptyState.module.css'

const WalletItemsEmptyState: FC<{
	address?: string
	className?: string
}> = (props) => {
	const { className, address } = props

	const emptyStateMessage = React.useMemo(() => {
		if (address) {
			return 'This address does not own any inscriptions'
		} else {
			return 'Get mint alerts for our next drop!'
		}
	}, [address])

	return (
		<div className={classNames({ [(props.className as any)]: !!className }, styles.root)}>
			<div className={styles.emptyContainer}>
				<GradientText classNames={classNames(styles.emptyTitle, 'display-lg', 'semibold')}>
					NGMI
				</GradientText>
				<p className={classNames(styles.emptyText, 'text-lg', 'regular')}>{emptyStateMessage}</p>
			</div>
			<div className={styles.emailContainer}>
				{!address && (
					<EmailWaitlist
						className={styles.email}
						inputClassname={styles.input}
						buttonClassname={styles.button}
						buttonLabel={'Get mint alerts'}
						successTitle={`Your're getting mint alerts!`}
						tweetIntent={
							'gm KINGS!\n\nI just signed up for mint alerts on @ordinalswallet!\n\njoin here: ordinalswallet.com\n\nplz RT'
						}
						waitlist={[MINT_ALERTS, LAUNCH_ALERTS]}
					/>
				)}
			</div>
		</div>
	)
}

export default WalletItemsEmptyState
